var map = {
	"./Online-Shop_Fullfillment.png": 5953,
	"./VAS.png": 5644,
	"./logo-color-text-transparent.png": 8030,
	"./packer-crew-team.jpg": 9234,
	"./packer-crew-team_OLD.jpg": 6016,
	"./partners/allcox_R.png": 2480,
	"./partners/allcox_persona_rgb.png": 7946,
	"./partners/thumbnail_allcox_persona_rgb.jpg": 6357,
	"./pc-logo.png": 2715,
	"./services/Co-packing.png": 2909,
	"./services/Lagerlogistik.png": 5658,
	"./services/Produktionsarbeiten.png": 1797,
	"./services/Produktveredelung.png": 3545,
	"./services/aktionen.png": 8770,
	"./services/chargenverfolgung.png": 8584,
	"./services/etikettierung.png": 713,
	"./services/kodierung.png": 6223,
	"./services/online-shop_fulfillment.png": 1984,
	"./services/qualitatskontrolle.png": 6835,
	"./services/shrinking.png": 60,
	"./services/sleeving.png": 972,
	"./videos/production.mp4": 4696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;